export type PostMessageItem = {
  product_id: string;
  color_id: string;
  title: string;
  price: string;
  size_mpn: string;
  gtin: string;
};

//Analytics
export type CartItem = {
  item_id: string;
  item_name: string;
  affiliation: string;
  coupon: string;
  currency: string;
  discount: number;
  index: number;
  item_brand: string;
  item_category: string;
  item_list_id: string;
  item_list_name: string;
  item_variant: string;
  location_id: string;
  price: number;
  quantity: number;
};

//View item
export interface ViewItemObject {
  event: 'view_item';
  currency: string;
  value: string;
  items: CartItem[];
  room_aggregator: string;
}

export function dispatchViewItemAnalytics(
  currency = 'USD',
  value: string,
  analyticItems: Array<CartItem>,
  room_aggregator: string,
) {
  room_aggregator = mapRoomAggregatorToStandard(room_aggregator);
  const item: ViewItemObject = {
    event: 'view_item',
    currency: currency,
    value: value,
    items: analyticItems,
    room_aggregator: room_aggregator,
  };
  pushToAnalytics(item, true);
}

//Add To Cart
export interface AddToCartObject {
  event: 'add_to_cart';
  currency: string;
  value: string;
  items: CartItem[];
  room_aggregator: string;
}

export function dispatchAddToCartAnalytics(
  currency = 'USD',
  value: string,
  analyticItems: Array<CartItem>,
  room_aggregator: string,
) {
  room_aggregator = mapRoomAggregatorToStandard(room_aggregator);
  const item: AddToCartObject = {
    event: 'add_to_cart',
    currency: currency,
    value: value,
    items: analyticItems,
    room_aggregator: room_aggregator,
  };
  pushToAnalytics(item, true);
}

//Collect Item
export interface CollectItemObject {
  event: 'collect_item';
  item_name: string;
  room_aggregator: string;
  progress: string;
}

export function dispatchCollectItemAnalytics(item_name: string, progress: string, room_aggregator: string) {
  room_aggregator = mapRoomAggregatorToStandard(room_aggregator);
  const item: CollectItemObject = {
    event: 'collect_item',
    item_name: item_name,
    room_aggregator: room_aggregator,
    progress: progress,
  };
  pushToAnalytics(item, false);
}

//Enable Audio
export interface EnableAudioObject {
  event: 'enable_audio';
  audioEnabled: boolean;
  room_aggregator: string;
}

export function dispatchAudioAnalytics(audioEnabled: boolean, room_aggregator: string) {
  room_aggregator = mapRoomAggregatorToStandard(room_aggregator);
  const item: EnableAudioObject = {
    event: 'enable_audio',
    audioEnabled: audioEnabled,
    room_aggregator: room_aggregator,
  };
  pushToAnalytics(item, false);
}

//Open Additional Media
export interface OpenAdditionalMediaObject {
  event: 'open_additional_media';
  room_aggregator: string;
  items?: CartItem[];
  partnership: string;
  url: string;
}

export function dispatchOpenAdditionalMediaObject(
  room_aggregator: string,
  partnership: string,
  url: string,
  items?: CartItem[],
) {
  room_aggregator = mapRoomAggregatorToStandard(room_aggregator);
  const item: OpenAdditionalMediaObject = {
    event: 'open_additional_media',
    room_aggregator: room_aggregator,
    items: items,
    partnership: partnership,
    url: url,
  };
  pushToAnalytics(item, false);
}

//Web3 Wallet Connect
export interface Web3WalletConnectObject {
  event: 'web3_wallet_connect';
  room_aggregator: string;
  wallet_id: string;
  wallet_successful_connect: boolean;
}

export function dispatchWeb3WalletConnect(
  wallet_id: string,
  wallet_successful_connect: boolean,
  room_aggregator: string,
) {
  room_aggregator = mapRoomAggregatorToStandard(room_aggregator);
  const item: Web3WalletConnectObject = {
    event: 'web3_wallet_connect',
    room_aggregator: room_aggregator,
    wallet_id: wallet_id,
    wallet_successful_connect: wallet_successful_connect,
  };
  pushToAnalytics(item, false);
}

//CTA Click
export interface CTAClickObject {
  event: 'cta_click';
  room_aggregator: string;
  cta_type: string;
  cta_name: string;
  cta_url: string;
  cta_action: string;
}
export function disptchCTAClickObject(
  room_aggregator: string,
  cta_type: string,
  cta_name: string,
  cta_action: string,
  cta_url: string,
) {
  room_aggregator = mapRoomAggregatorToStandard(room_aggregator);
  const item: CTAClickObject = {
    event: 'cta_click',
    room_aggregator: room_aggregator,
    cta_type: cta_type,
    cta_name: cta_name,
    cta_url: cta_url,
    cta_action: cta_action,
  };
  pushToAnalytics(item, false);
}

//Purchase
export interface PurchaseObject {
  event: 'purchase';
  transaction_id: string;
  currency: string;
  value: number;
  items: CartItem[];
  room_aggregator: string;
}

export function dispatchPurchaseAnalytics(
  transaction_id: string,
  currency: string,
  value: number,
  items: CartItem[],
  room_aggregator: string,
) {
  room_aggregator = mapRoomAggregatorToStandard(room_aggregator);
  const item: PurchaseObject = {
    event: 'purchase',
    transaction_id: transaction_id,
    currency: currency,
    value: value,
    items: items,
    room_aggregator: room_aggregator,
  };
  pushToAnalytics(item, true);
}

//StartTagManager
export interface StartTagManagerObject {
  event: 'startTagManager';
  room_aggregator: string;
}

export function dispatchStartTagManagerAnalytics(room_aggregator: string) {
  room_aggregator = mapRoomAggregatorToStandard(room_aggregator);
  const item: StartTagManagerObject = {
    event: 'startTagManager',
    room_aggregator: room_aggregator,
  };
  pushToAnalytics(item, false);
}

export function pushToAnalytics(object: any, isEcommerece: boolean) {
  // console.log(process.env);
  if (process.env.NODE_ENV === 'development') {
    return;
  }
  // console.log('Shahzaib Analytics ', object.event, object.room_aggregator);
  // console.log('Full Object', object);
  initializeMixPanel();
  const url = window.location.href;
  const params = new URLSearchParams(url);

  object.room_name = window.krpano != undefined ? window.krpano.get('scene[get(xml.scene)].room') : 'None';
  object.position = window.krpano != undefined ? window.krpano.get('xml.scene') : 'None';
  if (localStorage.getItem('locale')) {
    object.locale = localStorage.getItem('locale');
  } else {
    object.locale = params.has('locale') ? params.get('locale') : 'en';
  }

  if (window.mixpanel != undefined) window.mixpanel.track(object.event, Object.create(object));
  if (isEcommerece) {
    object = {
      event: object.event,
      ecommerce: object,
    };
  }
  if (window.emperiaTag != undefined) window.emperiaTag.pushEvent(object);
  else {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(object);
  }
}

function initializeMixPanel() {
  if (!window.mixpanel.track) {
    window.mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
      debug: false,
      track_pageview: false,
      persistence: 'localStorage',
    });
  }
}
/* Legacy Analytics
export function dispatchExternalLinkAnalytics(url: string) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'external_link',
    gtm: {
      elementUrl: url,
    },
  });
}


export function dispatchSelectContentAnalytics(type: string, id: string) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'select_content',
    content_type: type,
    item_id: id,
  });
}

export function dispatchAudioAnalytics(audioEnabled: boolean) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'enable_audio',
    audioEnabled: audioEnabled,
  });
}
*/

export function mapRoomAggregatorToStandard(roomAgregator: string) {
  if (roomAgregator == 'la_roca' || roomAgregator == 'la_vallee') {
    console.log('full object its wrong', roomAgregator);
    return roomAgregator.replace('_', '');
  }
  return roomAgregator;
}
